import React, { useMemo, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InitiativesTable from '../InitiativesTable';
import InterventionsForm from './InterventionsForm';
import { INTERVENTIONS_MOCK } from '../mockData';
import '../initiatives.scss';

const TABLE_COLUMNS = [
  { key: 'project_objective', label: 'Project Objective', width: '22%' },
  { key: 'project_id', label: 'Project ID', width: '12%' },
  { key: 'project_description', label: 'Project Description', width: '30%' },
  { key: 'user_name', label: 'User Name', width: '18%' },
  { key: 'report_to', label: 'Report To', width: '18%' },
];

const InterventionsPage = () => {
  const [rows, setRows] = useState(INTERVENTIONS_MOCK.row_data);
  const [editMode, setEditMode] = useState(false);
  const [formMode, setFormMode] = useState('create');
  const [editData, setEditData] = useState({});

  const columns = useMemo(() => TABLE_COLUMNS, []);

  const handleAdd = () => {
    setFormMode('create');
    setEditData({});
    setEditMode(true);
  };

  const handleProjectClick = (row) => {
    setFormMode('edit');
    setEditData(row);
    setEditMode(true);
  };

  const handleSave = (payload) => {
    setRows((prev) => {
      const idx = prev.findIndex((r) => r.project_id === payload.project_id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], ...payload };
        return next;
      }
      const projectId = payload.project_id || `I${prev.length + 1}-FY27`;
      return [{ ...payload, project_id: projectId }, ...prev];
    });
    setEditMode(false);
  };

  return (
    <div className="initiatives-jklc">
      {editMode ? (
        <InterventionsForm
          mode={formMode}
          initialData={editData}
          onBack={() => setEditMode(false)}
          onSave={handleSave}
        />
      ) : (
        <Box>
          <Box className="initiatives-jklc__toolbar">
            <Tooltip title="Create Initiatives">
              <button
                type="button"
                className="initiatives-jklc__create-btn"
                onClick={handleAdd}
              >
                <AddCircleOutlineIcon fontSize="small" />
                Initiatives
              </button>
            </Tooltip>
          </Box>
          <InitiativesTable
            columns={columns}
            rows={rows}
            onProjectClick={handleProjectClick}
          />
        </Box>
      )}
    </div>
  );
};

export default InterventionsPage;
